<template>
  <div>
      <!-- :typeData="item" -->
    <TypeCell v-for="item in imageDate" :Key="item.imagePath" :imgPath ="item.imagePath"  ></TypeCell>
  </div>
</template>

<script>
import TypeCell from "@/components/AboutExamination/TypeCell";
export default {
  components: {
    TypeCell
  },
  data() {
    return {
       imageDate: [
        {
          imagePath: require("@/assets/ksxg/tx_001.png"),
        },
        {
          imagePath: require("@/assets/ksxg/tx_002.png"),
        },
        {
          imagePath: require("@/assets/ksxg/tx_003.png"),
        },
        {
          imagePath: require("@/assets/ksxg/tx_004.png"),
        }
      ],

      typeDatas: [
        {
          title: "题型一：语料朗读/听读",
          des:
            "可选语料形式：词汇/短语/句子/语篇出题形式：系统以文本或音频的形式提供要求朗读的内容，考生参照朗读。题型解读：本题型从不同形式的文本层面考查考生的语音面貌。考生需要清晰、准确地读出屏幕上显示的词汇、句子语篇，在朗读过程中，需要注意元音、辅音的发音规范以及连读、重读、语调等发音技巧的运用。"
        },
        {
          title: "题型二：情景应答",
          des:
            "可选语料形式：句子/短对话/长对话出题形式：本题是通过预设一个场景任务，让考生根据所设条件补全信息、选择正确答语或完整应答。题型解读：本部分题目实际属于半开放题型，通过屏幕以文本形式给出的既定场景，将口头表达的范围限制在一个非常小的区域内。通常情况下，考生所需回答的所有信息在提示语中已经给出，只需重新组织语言“复述”出来即可。"
        },
        {
          title: "题型三：话题简述",
          des:
            "出题形式：本题通过限定一个主题，并给出部分信息参考词的形式，让考生根据所给信息组织话语完成话题表达。题型解读：本部分题目属于开放题型，考查考生口语综合应用的能力。在所给信息相对较少的情况下，考生须组织语言，在很短的时间内用符合表达规则和习惯底的话语完成表达任务。"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.cell-container {
}
</style>
